import { FlowcountEngine } from '../domain/engine';
import type { FlowcountState } from '../domain/types';
import { createDemoState } from './demoSeed';

const STORAGE_KEY = 'flowcount-demo-state-v1';

function load(): FlowcountState {
  if (typeof localStorage === 'undefined') return createDemoState();
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return createDemoState();
  try { return JSON.parse(raw) as FlowcountState; } catch { return createDemoState(); }
}

export class DemoStore extends FlowcountEngine {
  constructor() { super(load()); }
  save() {
    if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, JSON.stringify(this.state));
  }
  reset() {
    this.state = createDemoState();
    this.save();
  }
}

export const demoStore = new DemoStore();
